export class BaseStore {
  get() {
    return this.store.getState();
  }

  set(state) {
    this.store.setState(state);
  }
}
